export default __webpack_public_path__ + "358ad7dea485bc104c3ef56b2b3786da.png";